import TierModel from './TierModel.js';

export default function ProfileMetaModel(dict) {
    if (!dict) {
        this.basePoint = 0;
        this.birthMonth = null;
        this.tier = null;
        return;
    }
    
    this.basePoint = dict.BasePoint || 0;
    this.birthMonth = dict.BirthMonth || null;
    this.tier = dict.Tier ? new TierModel(dict.Tier) : null;
}